import { DataCollectionValues } from '../../types/DataCollectionValues';
import transformStringsToTypes from './transformStringsToTypes';

type apiResponseType = {
    status: 'OK' | 'NOK';
    error?: string;
    redirectUrl?: string;
};

async function callWizardApi(apiUrl: string, data: DataCollectionValues): Promise<apiResponseType> {
    const wizardData = transformStringsToTypes(data);
    const response = await fetch(apiUrl, {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(wizardData),
    });
    if (!response.ok) {
        throw new Error('[callWizardApi] communication error');
    }
    return response.json();
}

export default callWizardApi;
